import { validateEmail } from './../utils'
import _ from 'lodash'
import API from './../../api'
import AuthUser from "../../auth";

const DEFAULT_SERVER_SIDE_RESPONSE = {
  "hasResponse": false,
  "responseType": '',
  "header": "",
  "message": ""
};

const DEFAULT_FEEDBACK_FORM = {
  email: "",
  message: "",
  messageValidation: "",
  emailValidation: "",
};

/**
 * Person Form Validator
 */
export default {
  namespaced: true,
  state: {
    serverSideResponse: _.clone(DEFAULT_SERVER_SIDE_RESPONSE),
    feedbackForm: _.clone(DEFAULT_FEEDBACK_FORM),
  },
  mutations: {
    setServerSideResponse (state, response) {
      state.serverSideResponse = response
    },
    setFormValue (state, form) {
      state.feedbackForm = _.merge(state.feedbackForm, form);
    },
  },
  actions: {
    resetForm: async ({ commit }) => {
      commit('setLoading', false, { root: true })
      commit('setFormValue', _.clone(DEFAULT_FEEDBACK_FORM));
      commit('setServerSideResponse', _.clone(DEFAULT_SERVER_SIDE_RESPONSE));
    },

    /**
     * Get a page
     * @param commit
     * @param pageID
     * @returns {Promise<void>}
     */
    feedback: async ({ commit, state }) => {
      commit('setLoading', true, { root: true })
      try {
        let user = AuthUser.getAuthUser();

        let message = state.feedbackForm.message.trim();
        let email = state.feedbackForm.email.trim() || user.email;
        if (_.isEmpty(message)) {
          commit('setLoading', false, { root: true })
          commit('setFormValue', {
            messageValidation: 'is-invalid',
          });
          return ;
        }
        commit('setFormValue', {
          messageValidation: 'is-valid',
        });


        if (_.isEmpty(email) || validateEmail(email) === false) {
          commit('setLoading', false, { root: true })
          commit('setFormValue', {
            emailValidation: 'is-invalid',
          });
          return;
        }
        commit('setFormValue', {
          emailValidation: 'is-valid',
        });


        //ok, form validation passed, let's reset the form
        await API.sendFeedback(email, state.feedbackForm.message);
        commit('setFormValue', DEFAULT_FEEDBACK_FORM);
        commit('setServerSideResponse', {
          "hasResponse": true,
          "responseType": 'success',
          "header": "Thank you for your feedback.",
          "message": "Our team will contact you shortly if your feedback requires our responses.",
        });
        commit('setLoading', false, { root: true });
      } catch (e) {
        console.log(e);
        commit('setLoading', false, { root: true });
        commit('setServerSideResponse', {
          "hasResponse": true,
          "responseType": 'danger',
          "header": "oops",
          "message": "bot-message",
        });
      }
    },
  },
  getters: {
    feedbackForm: state => state.feedbackForm,
    serverSideResponse: state => state.serverSideResponse,
  }
}
